import {PaymentInstructionStatusGroup} from '@sollapay/enums';
import {formatNIS} from '@sollapay/utils';
import {useTranslation} from 'react-i18next';

import {KpiCard} from '../activity';

import type {PaymentInstructionsSummary} from '@sollapay/domain/rules';

export interface InstructionsKpiCardsProps {
  summary: PaymentInstructionsSummary;
  activeGroup: PaymentInstructionStatusGroup | 'all';
  onSelectGroup: (group: PaymentInstructionStatusGroup) => void;
}

/** Always reflects the whole account (ignores the table's active filters) — same convention as the Overview tab's stats. */
export function InstructionsKpiCards({
  summary,
  activeGroup,
  onSelectGroup
}: InstructionsKpiCardsProps) {
  const {t} = useTranslation('trustAccounts');

  return (
    <div className="grid grid-cols-3 gap-6">
      <KpiCard
        icon="clock"
        label={t('view.instructions.kpi.inProgress')}
        value={summary.inProgress.count.toLocaleString()}
        change={null}
        changeLabel=""
        noChangeLabel={formatNIS(summary.inProgress.amount)}
        isSelected={activeGroup === PaymentInstructionStatusGroup.IN_PROGRESS}
        onClick={() => onSelectGroup(PaymentInstructionStatusGroup.IN_PROGRESS)}
      />
      <KpiCard
        icon="alert-circle"
        label={t('view.instructions.kpi.needsAttention')}
        value={summary.needsAttention.count.toLocaleString()}
        change={null}
        changeLabel=""
        noChangeLabel={
          summary.needsAttention.count > 0
            ? t('view.instructions.kpi.awaitingAction')
            : t('view.instructions.kpi.noneAwaitingAction')
        }
        valueClassName={summary.needsAttention.count > 0 ? 'text-text-warning' : undefined}
        isSelected={activeGroup === PaymentInstructionStatusGroup.NEEDS_ATTENTION}
        onClick={() => onSelectGroup(PaymentInstructionStatusGroup.NEEDS_ATTENTION)}
      />
      <KpiCard
        icon="check-circle"
        label={t('view.instructions.kpi.completed')}
        value={summary.completed.count.toLocaleString()}
        change={null}
        changeLabel=""
        noChangeLabel={formatNIS(summary.completed.amount)}
        isSelected={activeGroup === PaymentInstructionStatusGroup.COMPLETED}
        onClick={() => onSelectGroup(PaymentInstructionStatusGroup.COMPLETED)}
      />
    </div>
  );
}
